import React from "react";
import "./Heading_title.css";

const Heading_title = (props) => {
  return (
    <>
      <section className="Heading_title_sec">
        {props.title && <h1 className="sectitle">{props.title}</h1>}
        {props.subtitle && <p className="subtitle">{props.subtitle}</p>}
      </section>
    </>
  );
};

export default Heading_title;
